export const truncateCharCount = (text: string, max: number): string => {
  if (text?.length > max) {
    return text.substr(0, max) + '...';
  }

  return text;
};
